export default "__VITE_ASSET__DD2bFlmK__"